import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './modalView.scss';

export function setBodyOverflowValueTo(value) {
    $('body').css('overflow', value);
}

export default function ModalView(modals) {
    class ModalViewComponent extends Component {
        static propTypes = {
            modal: PropTypes.shape({
                type: PropTypes.any,
            }).isRequired,
            closeModal: PropTypes.func.isRequired,
        };

        constructor(props) {
            super(props);

            props.closeModal();
        }

        componentDidUpdate() {
            const currentBodyVisibility = $('body').css('overflow');

            if (!this.shouldRenderModal && currentBodyVisibility === 'hidden') {
                setBodyOverflowValueTo('auto');
            } else if (this.shouldRenderModal) {
                setBodyOverflowValueTo('hidden');
            }
        }

        componentWillUnmount() {
            setBodyOverflowValueTo('auto');
        }

        get shouldRenderModal() {
            return this.props.modal.type;
        }

        render() {
            if (this.shouldRenderModal) {
                return (
                    <div className={styles['modal-view-container']}>
                        {React.createElement(modals[this.props.modal.type], this.props)}
                    </div>
                );
            }

            return null;
        }
    }

    return ModalViewComponent;
}
